import { client } from 'utils/contentful-client';
import {
  FETCH_CONTENTFUL,
  setContentCacheMap,
  fetchContentfulMessages,
  fetchContentfulStart,
  fetchContentfulEnd,
  fetchContentfulError,
  setContentful,
} from 'redux/contentful';
import { fetchAppSettings } from 'redux/appSettings';
import logError from 'utils/errorHandler';

/**
 * * Redux Middleware for Contentful fetch action - FETCH_CONTENTFUL
 *
 * @param {Parameters in action.payload}
 * @param id - contentful ID
 * @param content_type - contentful content type
 * @param include - default contentful - 3
 * @param label - contentful name ie. home, howItWorks
 * @param limit - limit of how many entries to fetch - 100 default
 * @param customSetContent - custom setting function for unique content that needs to be scrubbed (errorMessages)
 *
 */

const contentfulMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  next(action);

  const store = getState();

  if (action.type === setContentCacheMap.toString()) {
    dispatch(fetchAppSettings());
    dispatch(fetchContentfulMessages());
  }

  // Middleware only for getting contentful entries
  if (action.type !== FETCH_CONTENTFUL) return;

  // grab values from payload
  const { id = '', content_type = '', include = 3, label = '', limit = 100, order = '', query, customSetContent } = action.payload;

  // params object to send to contentful based on id exists or not
  const params = id
    ? {
        'sys.id': id,
        include,
      }
    : {
        content_type,
        order,
        include,
        limit,
        ...query,
      };

  // set loading state
  dispatch(fetchContentfulStart(label));

  client(params, store)
    .getEntries(params)
    .then((data) => {
      if (customSetContent) {
        dispatch(customSetContent({ data }));
      } else {
        dispatch(setContentful({ label, data }));
      }
      // clear loading state
      dispatch(fetchContentfulEnd());
    })
    .catch((error) => {
      // set error in contentful store
      dispatch(fetchContentfulError({ error: error.message }));
      // dispatch error for logging
      logError(error);
      // clear loading state
      dispatch(fetchContentfulEnd(label));
    });
};

export default contentfulMiddleware;
